import { c as _c } from "react/compiler-runtime";
import { gql, useMutation } from '@material-bank/graphql-client';
type SaveStatus = {
  __typename?: 'SaveStatus';
  isSaved: boolean;
  folderIds: string[];
};
type SaveProductData = {
  saveProduct: SaveStatus;
};
type SaveProductVars = {
  variantSku: string;
};
const saveProductMutation = gql`
  mutation SaveProduct($variantSku: String!) {
    saveProduct(variantSku: $variantSku) {
      isSaved
      folderIds
    }
  }
`;
export function useSaveProductMutation() {
  const $ = _c(5);
  const [mutate, t0] = useMutation(saveProductMutation);
  const {
    data,
    loading,
    error
  } = t0;
  const t1 = data?.saveProduct ?? null;
  let t2;
  if ($[0] !== error || $[1] !== loading || $[2] !== mutate || $[3] !== t1) {
    t2 = {
      saveProduct: mutate,
      data: t1,
      loading,
      error
    };
    $[0] = error;
    $[1] = loading;
    $[2] = mutate;
    $[3] = t1;
    $[4] = t2;
  } else {
    t2 = $[4];
  }
  return t2;
}